import { formatPrice, formatWholeCents } from "./teamCurrencyFormatting";

export const TICKET_COUNT_BASIS = "ticket_count";
export const GROSS_TICKET_SALES_BASIS = "gross_ticket_sales";

const parseAmount = (value) => parseFloat(String(value ?? "").replace(/,/g, "")) || 0;

export const dealBracketWidth = (bracket, basis) =>
  basis === GROSS_TICKET_SALES_BASIS ? parseAmount(bracket.gross_amount) : parseAmount(bracket.quantity);

export const dealBracketWidthLabel = ({ bracket, basis, isFirst, currency }) => {
  const lead = isFirst ? "First" : "Next";
  const width = dealBracketWidth(bracket, basis);

  if (basis !== GROSS_TICKET_SALES_BASIS) return `${lead} ${Math.trunc(width).toLocaleString()} tickets`;

  const amount = Number.isInteger(width) ? formatWholeCents(width * 100, currency) : formatPrice(width, currency);
  return `${lead} ${amount} gross`;
};
